export enum MessageContent {
  Alerts = 'alerts',
  Messages = 'messages',
}
